import { render, staticRenderFns } from "./group_buy.vue?vue&type=template&id=6b974d0b&scoped=true&"
import script from "./group_buy.vue?vue&type=script&lang=js&"
export * from "./group_buy.vue?vue&type=script&lang=js&"
import style0 from "./group_buy.vue?vue&type=style&index=0&id=6b974d0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b974d0b",
  null
  
)

export default component.exports